import React, {Component} from 'react';
import {t} from 'l10n';

import ModalAddPhoto from '../../components/modals/ModalAddPhoto';

import 'sass/headers/memberPhotos.scss';

class HeaderMemberPhotos extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showModal: false
        }
    }

    render() {
        let editPhoto = false;

        let {showModal} = this.state;

        let {onUploadPhotoSuccess} = this.props;

        return (
            <header className="memberMyAllPhotos">
                <div className="content">
                    <h1>{t('My photos')}</h1>
                    <div className="text-header-memberphotos">

                        <ModalAddPhoto
                            editPhoto={editPhoto}
                            show={showModal}
                            closeFn={() => this.setState({showModal: false})}
                            onSuccess={onUploadPhotoSuccess}
                        />

                        <div>
                            <div className="add-photo-button" onClick={() => this.setState({showModal: true})}>{t('Add a photo')}</div>
                        </div>
                    </div>
                </div>
            </header>
        )
    }
}

export default HeaderMemberPhotos;


// WEBPACK FOOTER //
// ./src/components/member/HeaderMemberPhotos.js